export default "__VITE_ASSET__tWOClzlh__"